import {
  XERO_SNAPSHOT_FETCHED
} from 'utils/constants'

export default (state = {}, action) => {
  switch (action.type) {
    case XERO_SNAPSHOT_FETCHED: {
      return { ...state, ...action.data.xeroSnapshot };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/xero_snapshots.js